export enum FormType {
  SIGN_UP = "sign-up",
  FINAL = "final"
}